/*
  The single list of product categories.

  The admin form and the shop filter used to keep their own copies, and
  they had already drifted — admin offered "loose-stones" but the shop
  had no filter for it, so those products could never be filtered to.
  Both now read from here.

  `value` is what goes in products.category in the database (lowercase,
  hyphenated); `label` is what a person sees. Adding a category is a
  one-line change in this array — products.category is a plain text
  column, so no migration is needed.
*/

export const PRODUCT_CATEGORIES = [
  { value: 'rings', label: 'Rings' },
  { value: 'bracelets', label: 'Bracelets' },
  { value: 'pendants', label: 'Pendants' },
  { value: 'earrings', label: 'Earrings' },
  { value: 'pyramids', label: 'Pyramids' },
  { value: 'mala', label: 'Mala' },
  { value: 'crystal-angel', label: 'Crystal Angel' },
  { value: 'rudraksh', label: 'Rudraksh' },
  { value: 'clusters', label: 'Clusters' },
  { value: 'loose-stones', label: 'Loose Stones' },
];

/* Display name for a stored category value. Falls back to tidying the
   raw value, so a category added straight in the database still reads
   properly instead of showing "crystal-angel". */
export const categoryLabel = (value) => {
  if (!value) return '';
  const known = PRODUCT_CATEGORIES.find((c) => c.value === value);
  if (known) return known.label;

  return String(value)
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
};
